import { PaymentTemplatesContainer as PaymentTemplates } from './PaymentTemplatesContainer'

// eslint-disable-next-line import/no-default-export
export default PaymentTemplates
